import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { showHideFilterModalReducer } from "../../../../data/redux/slice/globalFiltersSlice";
import {
  fecthClientList,
  fetchAllClientIdist,
  fetchAllCommissionList,
} from "../../../../services/fetchListingData";
import {
  COMMISSION_ALL_ACL,
  COMMISSION_DOWNLOAD_ACL,
  COMMISSION_FILTER_ACL,
  COMMISSION_PAYIN_ACL,
  COMMISSION_PAYOUT_ACL,
} from "../../../../utility/constants/valueConstants";
import ResizeListner from "../../../../utility/ResizeListner";
import {
  CommissionListHeaders,
  MainClientHeaders,
} from "../../../../utility/TableHeaders";
import { CustomButton } from "../../../components/main_comps/custom_button";
import CustomModal from "../../../components/main_comps/custom_modal";
import CustomTable from "../../../components/main_comps/custom_table";
import CustomTabs from "../../../components/main_comps/custom_tabs";
import MainComponent from "../../../components/ui_comps/MainComponent";
import DownloadReportCommission from "./DownloadReportCommission";

const ActionComponent = ({ onClick }) => {
  return (
    <div style={{ display: "flex" }}>
      <CustomButton
        styles={{
          backgroundColor: "#38369C",
          border: "1px solid #38369C",
          marginLeft: "10px",
        }}
        title="Download Report"
        textStyles={{ color: "white" }}
        onClick={onClick}
      />
    </div>
  );
};

const tabs = [
  { name: "All", key: 0, aclValue: COMMISSION_ALL_ACL },
  { name: "Payin", key: 1, aclValue: COMMISSION_PAYIN_ACL },
  { name: "Payout", key: 2, aclValue: COMMISSION_PAYOUT_ACL },
];

function CommissionListIndex() {
  const { width, height } = ResizeListner();
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = useState(0);
  const [data, setData] = useState([]);
  const [totalElements, setTotalElements] = useState(100);
  const [totalPages, setTotalPages] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [commissionData, setCommiissionData] = useState([]);
  const [loading, setLoading] = useState(false);

  const CommissionList = useSelector(
    (state) => state.listingSlice.commissionList
  );
  const ClientList = useSelector(
    (state) => state.listingSlice.clientWithIdList
  );

  const filters = useSelector((state) => state.globalFiltersSlice);

  const alterData = () => {
    if (ClientList.length > 0 && CommissionList?.data?.clients.length > 0) {
      let data = [];
      ClientList?.map((obj, i) => {
        let cdata = CommissionList?.data?.clients?.filter(
          (element) => element.client_ref_id === obj.userId
        );
        data.push({ ...cdata[0], ...obj });
      });
      setCommiissionData(data);
    }
  };

  const dispatch = useDispatch();

  const aclData = useSelector((state) => state.aclSlice.aclList);

  useEffect(() => {
    dispatch(
      fetchAllCommissionList({
        page: 0,
        size: 10,
        dateRange:
          filters?.fromDate && filters?.toDate
            ? moment(filters?.fromDate).format("DD/MM/YYYY") +
              "-" +
              moment(filters?.toDate).format("DD/MM/YYYY")
            : "",
      })
    );

    dispatch(
      fetchAllClientIdist({
        page: 0,
        size: 10,
        isForDropdown: false,
      })
    );
  }, []);

  useEffect(() => {
    alterData();
  }, [CommissionList, ClientList]);
  return (
    <div
      style={{
        width: "100%",
        overflow: "auto",
        boxSizing: "border-box",
        backgroundColor: "white",
      }}
    >
      <MainComponent
        notificationRequired={false}
        onClickFilter={() => {
          dispatch(
            showHideFilterModalReducer({
              showFilterModal: true,
              filters: [
                "dateRange",
                "resellerName",
                "serviceProvider",
                "serviceType",
              ],
            })
          );
        }}
        headerTitle="Commission List"
        onClickFilterCall={() => {}}
      />
      <CustomTabs
        tabs={tabs}
        activeIndex={currentTab}
        passCurrentTab={(tab) => setCurrentTab(tab)}
        actionComponent={
          aclData.includes(COMMISSION_DOWNLOAD_ACL) ? (
            <ActionComponent
              onClick={() => {
                setShowDownloadModal(true);
              }}
            />
          ) : null
        }
      />

      <div style={{ padding: "0px 20px", overflow: "hidden" }}>
        <CustomTable
          styles={{
            maxHeight: height * 0.7,
            minHeight: height * 0.7,
          }}
          data={commissionData}
          headers={CommissionListHeaders}
          totalElements={CommissionList?.data?.totalRecords}
          totalPages={CommissionList?.data?.totalPages}
          handlePaginate={(page) => {
            setCurrentPage(page);
          }}
          onViewMore={(row) => {
            navigate("/clients/details", {
              state: {
                data: row,
              },
            });
          }}
          isCommissionList={true}
        />
      </div>
      {showDownloadModal && (
        <CustomModal
          headerTitle="Download Report"
          open={showDownloadModal}
          onClose={() => {
            setShowDownloadModal(false);
          }}
          containerStyle={{
            minWidth: 350,
            maxWidth: 450,
            height: "auto",
            maxHeight: 800,
          }}
        >
          <DownloadReportCommission />
        </CustomModal>
      )}
    </div>
  );
}

export default CommissionListIndex;
